export default __webpack_public_path__ + "static/buildkite-e953625ad847d1a6a7bbcd52feaa2047.png";